exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".el-tabs__content{overflow:visible}.el-tabs__item{color:#fff;font-size:22px}.el-tabs__item.is-active{color:#fff}.el-tabs__header{border-bottom:1px solid #85743c;padding-bottom:30px}.el-tabs__active-bar{height:4px;border-radius:2px;margin-top:10px}.el-icon-arrow-left,.el-icon-arrow-right{color:#fff}.el-tabs__nav-wrap:after{height:0}.el-tabs__active-bar{background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dbaf8e7c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/service.vue
// module id = 969
// module chunks = 0